import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citiProvicionMensField =`
id
provisionUniqueId
serviceProvisionMeans
serviceSystemName
serviceReachLink
`;



export const GET_CITIZEN_SERVICES_PROVICION_MEANS = gql`
query CitizenGetServicesProvisionMeans($filtering:ServiceProvisionObjectsFilterInputObject){
    citizenGetServicesProvisionMeans(filtering:$filtering){
    ${baseResponseGraphqlField}
    data {
      ${citiProvicionMensField}
    }
  }
}
`
;
